export default "__VITE_PUBLIC_ASSET__8c08ff47__"